import PropTypes from 'prop-types';
import React from 'react';

import Browser from '@wetransfer/concorde-browser';

import Store from '@app/store';
import Action from '@app/action';
import I18n from '@module/i18n';
import VideoIllustration from '@component/illustration/video-illustration';
import Button from '@component/form/element/button';

export default class Password extends React.Component {
  static propTypes = {
    secret: PropTypes.string,
    recipient: PropTypes.string,
    transfer: PropTypes.object,
  };

  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.state = {
      pending: false,
      password: '',
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.verifyPassword = this.verifyPassword.bind(this);
  }

  onChange(e) {
    this.setState({ password: e.target.value });
  }

  onKeyDown(e) {
    if (this.state.password && e.key === 'Enter') {
      this.verifyPassword();
    }
  }

  async verifyPassword() {
    const password = this.passwordNode.value;
    this.setState({ pending: true });

    const confirmed = await this.props.transfer.verifyPassword(
      this.props.secret,
      password,
      this.props.recipient
    );
    if (confirmed) {
      Store.dispatch(Action.Transfer.verifiedPassword(password));
      Store.dispatch(Action.Transfer.buildTransfer(confirmed, password));
      Store.dispatch(Action.Notification.clearTransfer());
    } else {
      Store.dispatch(
        Action.Notification.pushTransfer({ text: 'InvalidPassword' })
      );
      this.setState({ pending: false });
    }
  }

  // Render our view
  render() {
    const actionLabel = I18n.t('transfer.buttons.continue');
    const actionButton = (
      <button className="transfer__button transfer__button--inactive">
        {actionLabel}
      </button>
    );

    let footer = (
      <div className="transfer__footer">
        <button className="transfer__button" onClick={this.verifyPassword}>
          {actionLabel}
        </button>
      </div>
    );

    const active = !this.state.pending && this.state.password;

    if (!active) {
      footer = <div className="transfer__footer">{actionButton}</div>;
    }

    return (
      <div className="transfer__window downloader">
        <div className="transfer__contents">
          <div className="downloader__password">
            <VideoIllustration
              src="transfer_window/transfer_password"
              type="transfer-password"
            />
            <h2>{I18n.t('transfer.password.title')}</h2>
            <p>{I18n.t('transfer.password.text')}</p>
            <input
              ref={(node) => (this.passwordNode = node)}
              type="password"
              className="transfer__textfield"
              onChange={this.onChange}
              onKeyDown={this.onKeyDown}
              placeholder={I18n.t('transfer.options.password')}
            />
            {Browser.isMobile ? (
              <Button
                text={actionLabel}
                active={active}
                onClick={this.verifyPassword}
              />
            ) : null}
          </div>
        </div>
        {Browser.isMobile ? null : footer}
      </div>
    );
  }
}
